import React from "react";
import { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import {serviceKeys, templateKeys, publicKeys} from "../../keys";
const FooterView = ({footerContactDetails = [], useFullLinks = [], projectLinks, onClickSetCurrentProject}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(serviceKeys, templateKeys, form.current, {
        publicKey: publicKeys,
      })
      .then(
        () => {
          alert("Email sent successfully!");
          setName("");
          setEmail("");
          setMsg("");
        },
        (error) => {
          alert("Email failed to send! pls try again");
        },
      );
  };

  return (
    <div className="flex bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 text-white max-w-screen-2xl xl:flex-row flex-col sm:min-w-[700px] min-w-[360px] mx-auto xl:h-[550px] px-40 shadow-2xl justify-around items-center rounded-t-lg animate-slide-up backdrop-blur-sm">
      <div className="w-[360px] h-[400px] flex flex-col justify-center items-center xl:items-baseline animate-fade-in">
        <h2 className="pt-[30px] font-bold text-lg text-primary-100 bg-clip-text text-transparent bg-gradient-to-r from-primary-50 to-primary-200">Contacts</h2>
        <form className="flex flex-col justify-center items-center xl:items-baseline space-y-4" ref={form} onSubmit={sendEmail}>
          <div className="flex flex-col w-full">
            <input
              id="name"
              onChange={(e) => setName(e.target.value)}
              className="mt-2 bg-white/10 w-[150px] self-start rounded-lg py-2 px-4 
                       border border-primary-400/50 text-white placeholder-primary-300 
                       focus:ring-2 focus:ring-primary-400 focus:border-transparent 
                       transition-all duration-200 hover:bg-white/20 hover:border-primary-300
                       shadow-lg hover:shadow-primary-400/20"
              type="text"
              name="from_name"
              placeholder="Type your name here..."
              value={name}
            />
          </div>
          <div className="flex flex-col w-full">
            <input
              id="email"
              onChange={(e) => setEmail(e.target.value)}
              className="w-[300px] bg-white/10 mt-2 rounded-lg py-2 px-4 
                       border border-primary-400/50 text-white placeholder-primary-300 
                       focus:ring-2 focus:ring-primary-400 focus:border-transparent 
                       transition-all duration-200 hover:bg-white/20 hover:border-primary-300
                       shadow-lg hover:shadow-primary-400/20"
              type="email"
              name="user_email"
              placeholder="Type your email here..."
              value={email}
            />
          </div>
          <div className="flex flex-col w-full">
            <textarea
              id="message"
              onChange={(e) => setMsg(e.target.value)}
              className="w-[300px] h-[150px] bg-white/10 rounded-lg mt-2 
                       border border-primary-400/50 py-2 px-4 text-white 
                       placeholder-primary-300 focus:ring-2 focus:ring-primary-400 
                       focus:border-transparent transition-all duration-200 
                       resize-none hover:bg-white/20 hover:border-primary-300
                       shadow-lg hover:shadow-primary-400/20"
              name="message"
              placeholder="Type your message here..."
              value={msg}
            />
          </div>
          <button 
            type="submit"
            className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-400 hover:to-primary-500 
                     rounded-full w-[130px] h-[50px] mt-4 font-bold text-lg text-white 
                     transform hover:scale-105 transition-all duration-200 
                     focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 
                     focus:ring-offset-primary-800 shadow-lg hover:shadow-primary-500/30"
          >
            Send
          </button>
        </form>
      </div>
      <div className="w-[360px] h-[320px] sm:h-[400px] flex flex-col sm:px-[5%] px-4 sm:items-center xl:items-baseline animate-fade-in delay-100">
        <h2 className="pt-[40px] font-bold text-lg w-[200px] text-primary-100">
          Projects:
        </h2>
        <div className="flex flex-col justify-between font-light mt-4 w-[360px]">
          {projectLinks.map((link, index) =>{
            return(
              <h2 
                onClick={()=>{onClickSetCurrentProject(link.id)}} 
                key={index} 
                className="h-10 px-6 text-m text-primary-200 hover:text-primary-100 cursor-pointer transition-colors duration-200 transform hover:translate-x-2"
              >
                {link.title}
              </h2>
            )
          })}
        </div>
      </div>
      <div className="w-[360px] h-[200px] sm:h-[360px] flex flex-row sm:flex-col items-center xl:items-center sm:justify-around animate-fade-in delay-200">
        <div className="flex w-[360px] h-full sm:h-[200px] flex-col px-4 gap-4 pt-4">
          {footerContactDetails.map((item, index) =>{
            return(
              <div 
                className="flex flex-wrap sm:gap-8 sm:pl-8 gap-2 h-8 items-center pl-2 group hover:transform hover:translate-x-2 transition-transform duration-200"
                key={index}
              >
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-[12px] h-[12px] filter brightness-0 invert group-hover:scale-110 transition-transform duration-200"
                />
                <a 
                  href={item.link} 
                  className="font-bold text-[14px] text-primary-200 group-hover:text-primary-100 transition-colors duration-200"
                >
                  {item.content}
                </a>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};
export default FooterView;
